/**
 * Created by Administrator on 2017/6/3 0003.
 * 管理api环境切换
 */
// 生产环境已全部切换为https
let url = location.href;
let protocol = location.href.split('://')[0]
let apiObj
if (protocol === 'https') {
  if (url.indexOf("wiadev.crland.com.cn") > -1) {
    apiObj = {
      // api: '/wx/'
      // api: 'http://192.168.31.253/'
      // 测试环境
      api: 'https://wiadev.crland.com.cn/',
      payUrl: 'https://wiadev.crland.com.cn/wechat/index.html#/pay/',
      // 上传附件
      fileUploadUrl: 'fileapi/icefile/upload.do'
    }
  } else {
    apiObj = {
      // api: '/wx/'
      // api: 'http://192.168.31.253/'
      // 生产环境
      api: 'https://wia.crland.com.cn/',
      payUrl: 'https://wia.crland.com.cn/wechat/index.html#/pay/',
      // 上传附件
      fileUploadUrl: 'fileapi/icefile/upload.do'
    }
  }
} else {
  apiObj = {
    api: '/wx/',
    // api: 'http://192.168.31.253/'
    // 测试环境
    // api: 'http://wiadev.crland.com.cn/',
    // payUrl: 'http://wiadev.crland.com.cn/wechat/index.html#/pay/'
    // 生产环境
    // api: 'http://wia.crland.com.cn/',
    // payUrl: 'http://wia.crland.com.cn/wechat/index.html#/pay/'
    // 上传附件
    fileUploadUrl: 'fileapi/icefile/upload.do'
  }
}

export default apiObj



// WEBPACK FOOTER //
// ./src/common/js/url.js